export default function Equation(age, education, bmi, bronchitis, personalHistory, familyHistory, ethnicity, smokingHistory, cigarettes, duration, quitTime) {

  const OR = (coefficient) => {
    return Math.pow(Math.E, coefficient)
  }

  const contribution = (value, referent, coefficient) => {
    return (value - referent) * coefficient;
  }

  const modelConstantContribution = -4.532506
  // age
  const ageReferent = 62;
  const ageCoefficient = 0.0778868
  const ageContribution = contribution(age, ageReferent, ageCoefficient);
  const ageOR = OR(ageCoefficient);
  console.log("age", ageContribution);

  // education
  const eduReferent = 4;
  const eduCoefficient = -0.0812744;
  const eduContribution = contribution(education, eduReferent, eduCoefficient);
  const eduOR = OR(eduCoefficient);
  console.log("edu", eduContribution);

  // bmi
  const bmiReferent = 27
  const bmiCoefficient = -0.0274194;
  const bmiContribution = contribution(bmi, bmiReferent, bmiCoefficient);
  const bmiOR = OR(bmiCoefficient);
  console.log("bmi", bmiContribution);

  // bronchitis
  const bronchitisCoefficient = 0.3553063
  const bronchitisContribution = contribution(bronchitis, 0, bronchitisCoefficient);
  const bronchitisOR = OR(bronchitisCoefficient);
  console.log("bronchitis", bronchitisContribution);

  // personal history
  const personalCoefficient = 0.4589971;
  const personalContribution = contribution(personalHistory, 0, personalCoefficient);
  const personalOR = OR(personalCoefficient);
  console.log("personal", personalContribution);

  // family history
  const familyCoefficient = 0.587185;
  const familyContribution = contribution(familyHistory, 0, familyCoefficient);
  const familyOR = OR(familyCoefficient);
  console.log("family", familyContribution);

  // ethnicity
  const ethnicityCoefficient = (ethnicity === 1) ? 0 : // white
    (ethnicity === 2) ? 0.3944778 : // black
      (ethnicity === 3) ? -0.7434744 : // hispanic
        (ethnicity === 4) ? -0.466585 : // asian
          (ethnicity === 5) ? 0 : // native hawaiian / pacific islander
            (ethnicity === 6) ? 1.027152 : 0; // american indian / alaskan native
  const ethnicityContribution = 0;
  const ethnicityOR = OR(ethnicityCoefficient);
  console.log('ethnicity', ethnicityContribution);

  // smoking history
  const smokingCoefficient = 0.2597431;
  const smokingContribution = contribution((smokingHistory), 1, smokingCoefficient); // how about person who doesnt smoke?
  const smokingOR = OR(smokingCoefficient);
  console.log('smoking', smokingContribution);

  // cigarettes 
  const cigReferent = -0.068820828;
  const cigCoefficient = -1.822606;
  const cigContribution = cigReferent * cigCoefficient;
  console.log('cig', (Math.pow((cigarettes / 10), -1) - 0.4021541613));

  // duration
  const durReferent = 27;
  const durCoefficient = 0.0317321;
  const durContribution = contribution(duration, durReferent, durCoefficient);
  const durOR = OR(durCoefficient);
  console.log('duration', durContribution);

  // quit time
  const quitReferent = 10;
  const quitCoefficient = -0.0308572;
  const quitContribution = contribution(quitTime, quitReferent, quitCoefficient);
  const quitOR = OR(quitCoefficient);
  console.log('quit time', quitContribution);

  // actual calculation
  const xb = modelConstantContribution + ageContribution + eduContribution + bmiContribution + bronchitisContribution + personalContribution + familyContribution + ethnicityContribution + smokingContribution + cigContribution + durContribution + quitContribution;

  const eXb = Math.pow(Math.E, xb);

  return ((eXb / (1 + eXb)) * 100).toFixed(2);

}